import { render, staticRenderFns } from "./PgRequestControl.vue?vue&type=template&id=4b32d037&"
import script from "./PgRequestControl.vue?vue&type=script&lang=js&"
export * from "./PgRequestControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports